import React, { useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ComplaintCard } from './ComplaintCard';
import { ComplaintPanel } from './ComplaintPanel';
import { complaints } from '../data/complaints';
import type { Complaint } from '../types/care';
const EASE = [0.23, 1, 0.32, 1] as const;

/** Grid of pain complaints; choosing one swaps the grid for its explanation and treatments. */
export function ComplaintExplorer() {
  const [active, setActive] = useState<Complaint | null>(null);
  const rootRef = useRef<HTMLDivElement>(null);
  const scrollToTop = () => {
    const top = rootRef.current?.getBoundingClientRect().top ?? 0;
    if (top < 0) rootRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  const openComplaint = (complaint: Complaint) => {
    setActive(complaint);
    scrollToTop();
  };
  const backToAll = () => {
    setActive(null);
    scrollToTop();
  };
  return <div ref={rootRef} className="scroll-mt-32" data-id="element-66" data-mp="2l0l2rbqiitqw">
      <AnimatePresence mode="wait" initial={false} data-id="element-67" data-mp="37yh2ua530iyv">
        {active ? <motion.div key={active.slug} initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2,
        ease: EASE
      }} className="max-w-4xl" data-id="element-68" data-mp="3cwsbwinjypg1">
            <ComplaintPanel complaint={active} onBack={backToAll} data-id="element-69" data-mp="3moob5x1dkllu" />
          </motion.div> : <motion.ul key="all" initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.18,
        ease: EASE
      }} className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4" data-id="element-70" data-mp="2p0xt14asuwbe">
            {complaints.map(c => <li key={c.slug} data-id="element-71" data-mp="e7judsct4kif">
                <ComplaintCard complaint={c} onSelect={() => openComplaint(c)} data-id="element-72" data-mp="e6ig7f0hvhwh" />
              </li>)}
          </motion.ul>}
      </AnimatePresence>
    </div>;
}